module.exports = __webpack_public_path__ + "img/startbild_default_header-video.a2f81369.jpg";